module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-wrapper box-desc-social"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                About Company\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio minus incidunt, quos libero a illo\n                  amet deleniti tempore, modi obcaecati autem vitae, labore doloribus reiciendis veniam quod minima\n                  quibusdam reprehenderit!\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                Contact Us\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Address: Jl TB Simatupang No.30 Gd Talavera Suite 6 BGH\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Phone: 085692268882\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Email: sales@xpitpilar.com\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box-desc-social"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Follow Us\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://facebook.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": "http://twitter.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "href": "http://google.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://linkedin.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-corpyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("2023 © Corpyright - XPIT PILAR")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-911801b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appFooter.vue
// module id = 83
// module chunks = 0